import React from "react";

import { Header, Footer } from "../../components/";

export function ClientLayout(props) {
  const { children } = props;
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}
